"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _range = _interopRequireDefault(require("./range"));

var S = _interopRequireWildcard(require("./styled"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Pagination = function Pagination(_ref) {
  var _ref$instance = _ref.instance,
      pageOptions = _ref$instance.pageOptions,
      previousPage = _ref$instance.previousPage,
      nextPage = _ref$instance.nextPage,
      canPreviousPage = _ref$instance.canPreviousPage,
      canNextPage = _ref$instance.canNextPage,
      gotoPage = _ref$instance.gotoPage,
      pageIndex = _ref$instance.pageIndex,
      pageCount = _ref.pageCount;
  var previousClassName = 'page-item previous' + (canPreviousPage ? '' : ' disabled');
  var nextClassName = 'page-item next' + (canNextPage ? '' : ' disabled');
  return /*#__PURE__*/_react["default"].createElement(S.Pagination, {
    className: "pagination my-3 m-lg-0"
  }, /*#__PURE__*/_react["default"].createElement("li", {
    className: "".concat(previousClassName, " first")
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "page-link",
    onClick: function onClick() {
      return gotoPage(0);
    },
    "data-test": "first-page"
  }, "First")), /*#__PURE__*/_react["default"].createElement("li", {
    className: previousClassName
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "page-link",
    onClick: function onClick() {
      return previousPage();
    },
    "data-test": "previous-page"
  }, "Previous")), (0, _range["default"])(pageIndex, pageOptions.length, 4).map(function (option, i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: i,
      className: (0, _classnames["default"])('page-item', {
        active: option !== '...' && pageIndex === option - 1
      })
    }, option === '...' ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "page-link disabled"
    }, option) : /*#__PURE__*/_react["default"].createElement("button", {
      className: "page-link",
      onClick: function onClick() {
        return gotoPage(option - 1);
      },
      "data-test": "page-".concat(option)
    }, option));
  }), /*#__PURE__*/_react["default"].createElement("li", {
    className: nextClassName
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "page-link",
    onClick: function onClick() {
      return nextPage();
    },
    "data-test": "next-page"
  }, "Next")), /*#__PURE__*/_react["default"].createElement("li", {
    className: "".concat(nextClassName, " last")
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "page-link",
    onClick: function onClick() {
      return gotoPage(pageCount - 1);
    },
    "data-test": "last-page"
  }, "Last")));
};

var _default = Pagination;
exports["default"] = _default;